import { Headline } from 'components/Headline';

import { useGridButtons } from './GridButtons.hooks';
import * as S from './GridButtons.styles';

export function GridButtons(): React.ReactElement {
  const { buttonsMapped } = useGridButtons();

  return (
    <S.Wrapper>
      <Headline fontFamily="LFT Zeno" color="grayDarkSecondary">
        View:
      </Headline>

      {buttonsMapped && <S.Container>{buttonsMapped}</S.Container>}
    </S.Wrapper>
  );
}
